import React from "react";
import clsx from "clsx";
import { Button, Typography } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import useInBodyApi from "@apis/useInBodyApi";
import useMessageDialog from "@util/hook/useMessageDialog";
import { isFunction } from "@util/utils";

/** ================================
 * 📌 量身使用
 * 顯示目前InBody裝置有人在使用
 * onRedoMeasurement 重新量身
 *  ================================
 */ 
const InBodyKickUserDialog = React.forwardRef((props, ref) => {
	const { className, open, onClose: onCloseProps, sourceData } = props;
	if (!open) return null;
	const { onRedoMeasurement: onRedoMeasurementProps } = sourceData;
	const { postCancelMeasureApi } = useInBodyApi();
	const setMessageDialog = useMessageDialog();

	const handleConfirm = () => {
		setMessageDialog({
			open: true,
			title: "警告",
			dialogActionsProps: { className: "flex-y-flex-start" },
			buttonColor: "success",
			onAsyncConfirm: (_e, _onClose) => {
				forceLogoutUserApi(_onClose);
			},
			MsgComp: () => (
				<React.Fragment>
					<Typography paragraph>請再次確認是否要取代正在量身會員的紀錄</Typography>
				</React.Fragment>
			),
		});
	};

	// 斷開正在使用Inbody的使用者
	const forceLogoutUserApi = async _onClose => {
		const resp = await postCancelMeasureApi();
		if (resp) {
			_onClose();
			isFunction(onRedoMeasurementProps) && onRedoMeasurementProps();
		}
	};

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-40rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={onCloseProps}>警告</GradientColorHeader>
			<DialogContent>
				<Typography paragraph>有人正在量身，確定要取消當前的量身嗎?</Typography>
			</DialogContent>
			<DialogActions>
				<Button color="error" variant="contained" onClick={onCloseProps}>
					否
				</Button>
				<Button color="success" variant="contained" onClick={handleConfirm}>
					是
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default InBodyKickUserDialog;
